module.exports = __webpack_public_path__ + "static/img/PubChem.cf96d03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PubChem.png
// module id = n+i9
// module chunks = 1